import React from "react";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import Button from "../../Button/Button";

// styles
import * as styles from "./ResourceCard.module.css";

const ResourceCard = ({
  image,
  category,
  title,
  description,
  ctaText,
  ctaLink,
  onCtaClick,
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const handleCtaClick = () => {
    if (onCtaClick) {
      onCtaClick(title, category);
    }
  };

  return (
    <div
      className={`${styles.resourceCard} scroll_animate ${inView && "inview"}`}
      ref={ref}
    >
      {/* Card Image */}
      <div className={styles.imageWrapper}>{image}</div>

      {/* Card Content */}
      <div className={styles.cardContent}>
        <div className={styles.categoryBadge}>{category}</div>
        <h3 className={styles.cardTitle}>{title}</h3>
        <p className={styles.cardDescription}>{description}</p>

        {/* CTA Button */}
        <Button
          text={ctaText}
          variant="outline"
          size="md"
          href={ctaLink}
          isExternal={true}
          onClick={handleCtaClick}
          btnClass={styles.ctaButton}
        />
      </div>
    </div>
  );
};

ResourceCard.propTypes = {
  image: PropTypes.node.isRequired,
  category: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string.isRequired,
  onCtaClick: PropTypes.func,
};

ResourceCard.defaultProps = {
  ctaText: "Read More",
  onCtaClick: null,
};

export default ResourceCard;
